import { Button, Header, Segment, SemanticSIZES } from 'semantic-ui-react';
import { Form, Formik } from 'formik';
import { PermitFormValues } from '../../../../app/models/permit';
import { observer } from 'mobx-react-lite';
import StepMenu from '../../steps/StepMenu';
import { useStore } from '../../../../app/stores/store';
import LoadingComponent from '../../../../app/layout/LoadingComponent';
import MySelectInput from '../../../../app/common/form/MySelectInput';
import { emptyValidationSchema } from '../../../../app/common/form/FormikFormValidations';

interface Props {
    values: PermitFormValues,
    next: () => void,
    handleChange: (name: string|any, value: string|object) => void,
    handleDropdownChange: (e: React.ChangeEvent<HTMLInputElement>, result: any) => void,
    goTo: (step: number) => void,
    buttonSize: SemanticSIZES
}

export default observer(function PermitFormStep1({ 
    values,
    next,
    handleChange,
    buttonSize
 }: Props) {
    const {permitStore} = useStore();
    const {
        routes,
        routeTerminals,
        loadRouteTerminals,
        getTerminalName,
        loadingInitial
    } = permitStore;
    const {routeId, amTerminalId, pmTerminalId, scheduleTypeInd} = values;

    function handleOnChangeRoute(route: string) {
        values.routeId = route;
        if(values.amTerminalId !== '') {
            values.amTerminalId = '';
        }
        loadRouteTerminals(+route);
    }

    function handleOnChangeAmTerminal(selectedTerminalId: string) {
        // set selected dropdown value
        values.amTerminalId = selectedTerminalId;

        // save dynamic data in values
        handleChange('amTerminalId', selectedTerminalId);
        
        if(routeTerminals.length > 0) {
            const pmTerminal = routeTerminals.filter((e => e.key !== selectedTerminalId))[0];
            
            // values.pmTerminalId = +pmTerminal.key;
            handleChange('pmTerminalId', pmTerminal.key);
        }
    }
    
    return (
        <Formik
            initialValues={new PermitFormValues(values)}
            onSubmit={() => next()}
            validationSchema={emptyValidationSchema}
        >
        {({handleSubmit, isSubmitting, dirty}) => (
            <Form className='ui form error' onSubmit={handleSubmit} autoComplete='off'>
                <StepMenu currentTab={1} position='top' permitTypeId={values.permitTypeId} />

                <Segment attached clearing>
                    <Header 
                        as='h2' 
                        icon='clipboard list' 
                        content='Route/Terminal Selection'
                    />

                    <Header 
                        as='h3'
                        content={`Select Route`}
                        color='black'
                        dividing
                    />
                    <MySelectInput 
                        options={routes} 
                        placeholder='--- Select Your Route ---'  
                        name='routeId'
                        defaultValue={`${routeId}`}
                        onChange={(value: string) => handleOnChangeRoute(value)}
                    />

                    {(values.routeId && routeTerminals.length > 0) && 
                        loadingInitial ? 
                            <LoadingComponent />
                    :
                        <>
                            <Header 
                                as='h3'
                                content={`Select Morning Departure`}
                                color='black'
                                dividing
                            />
                            <MySelectInput 
                                options={routeTerminals} 
                                placeholder='--- Select Your Terminal (AM Departure) ---'  
                                name='amTerminalId'
                                defaultValue={amTerminalId}
                                onChange={(value: string) => handleOnChangeAmTerminal(value)}
                            />

                            {values.amTerminalId && (
                                <Segment>
                                    <Header 
                                        as='h3'
                                        content={`Evening Departure`}
                                        color='black'
                                        dividing
                                    />
                                    { values.pmTerminalId > 0 &&
                                        <Header 
                                            as='h3'
                                            content={`${getTerminalName('' + values.pmTerminalId)}`}
                                            block
                                            inverted
                                            textAlign='center'
                                        />
                                    }
                                </Segment>
                            )} 
                        </>
                    }

                    <Button 
                        loading={isSubmitting}
                        disabled={!dirty || pmTerminalId === 0 || scheduleTypeInd === ''}
                        floated='right'
                        positive
                        type='submit'
                        content='Next'
                        size={buttonSize}
                    /> 
                </Segment>
            </Form>
            )}
        </Formik>
    )
})